import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './car-or-van-availability.reducer';

export const CarOrVanAvailabilityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const carOrVanAvailabilityEntity = useAppSelector(state => state.carOrVanAvailability.entity);
  const loading = useAppSelector(state => state.carOrVanAvailability.loading);
  const updating = useAppSelector(state => state.carOrVanAvailability.updating);
  const updateSuccess = useAppSelector(state => state.carOrVanAvailability.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/car-or-van-availability${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllHouseholds !== undefined && typeof values.totalAllHouseholds !== 'number') {
      values.totalAllHouseholds = Number(values.totalAllHouseholds);
    }
    if (values.noCarsVans !== undefined && typeof values.noCarsVans !== 'number') {
      values.noCarsVans = Number(values.noCarsVans);
    }
    if (values.oneCar !== undefined && typeof values.oneCar !== 'number') {
      values.oneCar = Number(values.oneCar);
    }
    if (values.twoCars !== undefined && typeof values.twoCars !== 'number') {
      values.twoCars = Number(values.twoCars);
    }
    if (values.threeOrMoreCars !== undefined && typeof values.threeOrMoreCars !== 'number') {
      values.threeOrMoreCars = Number(values.threeOrMoreCars);
    }

    const entity = {
      ...carOrVanAvailabilityEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...carOrVanAvailabilityEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.carOrVanAvailability.home.createOrEditLabel" data-cy="CarOrVanAvailabilityCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.carOrVanAvailability.home.createOrEditLabel">
              Create or edit a CarOrVanAvailability
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="car-or-van-availability-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.geographicLevel')}
                id="car-or-van-availability-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.date')}
                id="car-or-van-availability-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.geography')}
                id="car-or-van-availability-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.geographyCode')}
                id="car-or-van-availability-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.totalAllHouseholds')}
                id="car-or-van-availability-totalAllHouseholds"
                name="totalAllHouseholds"
                data-cy="totalAllHouseholds"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.noCarsVans')}
                id="car-or-van-availability-noCarsVans"
                name="noCarsVans"
                data-cy="noCarsVans"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.oneCar')}
                id="car-or-van-availability-oneCar"
                name="oneCar"
                data-cy="oneCar"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.twoCars')}
                id="car-or-van-availability-twoCars"
                name="twoCars"
                data-cy="twoCars"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.carOrVanAvailability.threeOrMoreCars')}
                id="car-or-van-availability-threeOrMoreCars"
                name="threeOrMoreCars"
                data-cy="threeOrMoreCars"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/car-or-van-availability" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CarOrVanAvailabilityUpdate;
